// components/BackToMap.jsx
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./BackToMap.module.scss";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";
import { IMAGES } from "../../constants/images";
import localforage from "localforage";
import { STORAGE_KEYS } from "../../constants/storage";

const BackToMap = ({ isContinue = false, goTo = "/temple-map" }) => {
  const navigate = useNavigate();
  const { interfaceText } = useContext(LanguageContext);
  const [cachedImage, setCachedImage] = useState(null);

  useEffect(() => {
    const loadCachedImage = async () => {
      const cachedImageBlob = await localforage.getItem(
        `${STORAGE_KEYS.IMAGES}_${IMAGES.BACK_TO_MAP_IMAGE}`
      );
      if (cachedImageBlob) {
        setCachedImage(URL.createObjectURL(cachedImageBlob));
      }
    };

    loadCachedImage();

    return () => {
      if (cachedImage) {
        URL.revokeObjectURL(cachedImage);
      }
    };
  }, []);

  return (
    <>
      <img
        src={cachedImage || IMAGES.BACK_TO_MAP_IMAGE}
        alt={""}
        className={styles.gradientOverlay}
      />
      <button
        className={`${styles.backToMap} ${isContinue === true ? styles.red : ""}`}
        onClick={() => navigate(goTo)}
      >
        {isContinue === false
          ? interfaceText.backToMap
          : interfaceText.continue}
      </button>
    </>
  );
};

BackToMap.propTypes = {
  isContinue: PropTypes.bool,
  goTo: PropTypes.string,
};

export default BackToMap;
